export const ALERT_TYPES = {
  SUCCESS : 'success',
  WARNING : 'warning',
  DANGER  : 'danger',
  INFO    : 'info'
}
